export default __webpack_public_path__ + "static/media/dad729ac1cc5915d9dd21d7376ef0858.png";